<template>
  <div>

    <memlist-modal ref="survey-editor-modal" size="full">
    
      <div ref="page-container" class="page-container">
        <div ref="top-container" class="top-container">
          <div class="left-menu" ref="navigation-drawer">
            <memlist-navigation-drawer
              :items="unlocked_sections.map(s => ({ icon: s.icon, value: s.value, text: s.title }))"
              @click="on_drawer_item_click"
            >
              <template v-slot:footer-button>
                
              </template>
            </memlist-navigation-drawer>
            <!--<div v-if="local_item_status === 'DRAFT' || local_item_status === 'ARCHIVED'">
              <memlist-icon-button
                class="mr-2 mt-4 w-100"
                icon="fa fa-play"
                :text="text_publish"
                variant="success"
                @click="publish_clicked"
              />
              
            </div>
            <div v-else-if="local_item_status === 'ACTIVE'">
              <memlist-icon-button
                class="mr-2 mt-4 w-100"
                icon="fa fa-archive"
                :text="text_archive"
                variant="primary"
                @click="archive_clicked"
              />
            </div>-->
            
          </div>

          <!-- fill the rest of the width -->
          <div class="content flex-grow-1 flex-fill">


            <div v-if="selected_section_name == 'basic_info'">

              <memlist-card
                title=""
                class="mb-2 edit-template-container"
                ref="edit-template"
                id="edit-template"
              >
                <form class="mt-8" @submit.prevent="saveTemplate">

                  <m-row>
                    <m-col lg="6">
                      <memlist-text-input
                        class="mt-4"
                        id="input-id"
                        v-model="form_data.id"
                        type="text"
                        required
                        disabled
                        title="ID"
                        layout="vertical"
                        size="sm"
                        validation_type="TEXT"
                      />

                      <div v-if="form_data.template_id">
                        <p style="font-weight: 500;" class="mt-4">Länk till publik sida</p>
                        <a @click.prevent="goto_url_clicked" target="_blank" class="ml-4 mb-8 ml-url-link legacy-link d-inline-flex align-items-center text-decoration-none">
                          <span class="svg-icon svg-icon-md text-primary me-2">
                            <i class="fa fa-link color-primary"></i>
                          </span>
                          <span class="ml-4 text-primary">{{ template_public_url }}</span>
                        </a>

                      </div>
                      
                      <memlist-text-input 
                        title="Namn på enkäten" 
                        id="name" 
                        name="name"
                        layout="vertical"
                        v-model="form_data.name" 
                        :placeholder="'Namn'"
                      />

                      
                    </m-col>
                  </m-row>

                  <m-row class="mt-8">
                    <m-col lg="12">
                      <memlist-checkbox 
                        text="Skicka svar till administratör via e-post" 
                        v-model="form_data.is_email_active" 
                      />
                    </m-col>
                  </m-row>

                  <m-row class="mt-4">
                    <m-col lg="6">
                      <memlist-select-input2
                        id="timeout_template_id"
                        name="timeout_template_id"
                        title="Aviseringsmall via e-post vid inaktivtet"
                        layout="vertical"
                        validation_type="TEXT"
                        v-model="form_data.timeout_template_id"
                        :items="email_template_options"
                        :invalid_text="''"
                        :info_text="''"
                      />
                    </m-col>
                  </m-row>

                  <m-row class="mt-4">
                    <m-col lg="6">
                      <memlist-datetime-picker
                        class="mt-8"
                        label="Öppet från"
                        v-model="form_data.from_datetime"
          
                      />
                      
                    </m-col>
                    <m-col lg="6">
                      
                      <memlist-datetime-picker
                        class="mt-8"
                        label="Öppet till"
                        v-model="form_data.to_datetime"
          
                      />
                    </m-col>
                  </m-row>



                  <div v-if="form_data.timeout_template_id">
                    <m-row class="mt-4" v-if="form_data.timeout_template_id">
                      <m-col lg="6">
                        <memlist-text-input 
                          title="Antal inaktiva dagar innan avisering skickas" 
                          id="timeout_days" 
                          name="timeout_days"
                          layout="vertical"
                          v-model="form_data.timeout_days" 
                          :placeholder="'Antal dagar'"
                        />
                      </m-col>
                    </m-row>

                    <m-row class="mt-4">
                      <m-col lg="12">
                        <p style="font-weight: 500; margin-bottom: 4px;">E-post att skicka till</p>
                        <Multiselect
                          style="height: 48px;"
                          class="multiselect-blue"
                          v-model="form_data.timeout_emails"
                          ref="tickets_multiselect"
                          mode="tags"
                          :options="form_data.timeout_emails"
                          :create-option="true"
                          :searchable="true"
                          :placeholder="'Ange e-post'"
                          :close-on-select="false"
                          @input="timeout_emails_changed"
                        />
                      </m-col>
                    </m-row>
                    
                  </div>

                  <hr />
                  
                  <RightModalSaveAndCloseButtons
                    :text="$t('COMMON.SAVE')"
                    :spin="true"
                    @click="submit_form"
                    @close="on_cancel"
                    ref="saveButton"
                  />
                
                </form>
                
              </memlist-card>

            </div>

            <div v-else-if="selected_section_name == 'designer'">
              <UnlayerWrapperComponent
                type="survey"
                :userId="currentCompanyId"
                :design="designObject"
                :locale="locale"
                @designSaved="on_design_saved"
                @plaintextGenerated="on_plaintext_generated"
                @auto_save="on_auto_save"
                ref="survey-unlayer-editor"
              />
                
            </div>
            <div v-else-if="selected_section_name == 'sender'">
            
            </div>
            <div v-else-if="selected_section_name == 'attachments'">
              
            </div>

          </div>
          
          
        
        </div>
      </div>
    </memlist-modal>
  </div>
</template>

<script>

import UnlayerWrapperComponent from '@/view/components/UnlayerWrapperComponent.vue';

import axios from 'axios';
import swal from 'sweetalert2';
import { upload_file } from '@/core/services/fileUpload';
import { get_domain_url, get_base_url, downloadWithAxios } from '@/core/services/fileDownload';
import { mapGetters } from 'vuex';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import Multiselect from '@vueform/multiselect/dist/multiselect.vue2.js';
import __tags from '@/assets/plugins/email-editor/merge-tags.js';
import RightModalSaveAndCloseButtons from '@/view/components/buttons/RightModalSaveAndCloseButtons.vue';
import { is_mobile } from '@/core/services/utils';

export default {
  name: 'SurveyEditorModal',
  mixins: [ toasts ],
  components: {
    RightModalSaveAndCloseButtons,
    UnlayerWrapperComponent,
    Multiselect,
  },
  props: {
    question_form_id: {
      type: Number,
      required: false,
      default: null,
    },
  },
  emits: ['updated', 'created', 'cancel'],
  computed: {
    linkstr() {
      return this.form_data.linkstr ? `${get_domain_url()}/answer/${this.form_data.linkstr}` : '';
    },
    designObject() {
      if (!this.design) {
        return {};
      }
      
      const design = this.isJson(this.design) ? JSON.parse(this.design) : this.design;
      
      try {
        return this.isJson(design) ? JSON.parse(design) : design;
      } catch (e) {
        console.error('designObject error', e);

        return design;
      }
    },
    locale() {
      return localStorage.getItem("language") || "sv";
    }, 
    is_mobile() {
      return is_mobile();
    },
    selected_section_name() {
      if (this.selected_item === undefined) {
        return '';
      }

      if (this.unlocked_sections[this.selected_item] === undefined) {
        return '';
      }

      return this.unlocked_sections[this.selected_item].name;
    },
    merge_tags_options() {
      return __tags.map(item => ({ text: item.name, value: `%${item.id}%` }));
    },
    template_public_url() {
      return get_domain_url() + `/template/public/${this.form_data.template_id}/${this.form_data.token}`;
    },
    
    sendout_template_type_options() {

      const base = [
        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.DONATION_NEW_DONATION_RECEIVED'), value: 'DONATION_NEW_DONATION_RECEIVED' },
        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.DONATION_THANK_YOU_SINGLE'), value: 'DONATION_THANK_YOU_SINGLE' },
        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.DONATION_THANK_YOU_RECURRING'), value: 'DONATION_THANK_YOU_RECURRING' },
        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.SIMPLE_FORM_ANSWERED'), value: 'SIMPLE_FORM_ANSWERED' },
        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.TICKET_EVENT'), value: 'TICKET_EVENT' },
        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.TICKET_EVENT_ADMIN_NOTIFICATION'), value: 'TICKET_EVENT_ADMIN_NOTIFICATION' },
        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.TODO_UPDATED'), value: 'TODO_UPDATED' },
      ];
      

      if (this.isTHS) {
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.SAMFUND_MEMBERS_ERROR_REPORT'), value: 'SAMFUND_MEMBERS_ERROR_REPORT' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.GENERAL_ERROR_REPORT'), value: 'GENERAL_ERROR_REPORT' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.DONATION_NEW_CUSTOMER'), value: 'DONATION_NEW_CUSTOMER' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.DONATION_WELCOME_ADMIN'), value: 'DONATION_WELCOME_ADMIN' });
      }

      if (this.global_settings.type === 'kvitto') {
        
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.EMAIL_NOT_MATCHED'), value: 'EMAIL_NOT_MATCHED' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.KVITTO_RECEIVED_AND_FORWARDED'), value: 'KVITTO_RECEIVED_AND_FORWARDED' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.KVITTO_ERROR'), value: 'KVITTO_ERROR' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.KVITTO_NO_RULE_MATCHED'), value: 'KVITTO_NO_RULE_MATCHED' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.KVITTO_RECEIVED'), value: 'KVITTO_RECEIVED' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.KVITTO_MATCHED'), value: 'KVITTO_MATCHED' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.KVITTO_NOT_MATCHED'), value: 'KVITTO_NOT_MATCHED' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.ACCOUNT_TRANSACTION_NEED_MATCH'), value: 'ACCOUNT_TRANSACTION_NEED_MATCH' });
      }

      if (this.global_settings.type === 'support') {

        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.SALES_INFO_MAIL'), value: 'SALES_INFO_MAIL' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.SALES_INVITE_MEETING'), value: 'SALES_INVITE_MEETING' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.SALES_FOLLOW_UP'), value: 'SALES_FOLLOW_UP' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.SALES_SIGN_CONTRACT'), value: 'SALES_SIGN_CONTRACT' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.SALES_WELCOME_AFTER_SIGN'), value: 'SALES_WELCOME_AFTER_SIGN' });
      }

      return base;
    },

    ...mapGetters(['currentCompanyId', 'currentPeriodId', 'periods', 'isTHS', 'unlocks', 'customer', 'global_settings']),

    validFromId() {
      return this.validate_from_id();
    },
    fullscreen_visible() {
      const display = this.fullscreen ? 'block' : 'none';
      return `display:${display}`;
    },
    templateDesign() {
      return this.form_data.edit_html;
    },
    creating() {
      return isNaN(parseInt(this.form_data.template_id+''));
    },
    valid_name_state() {
      if (!this.form_data.name) { return false; }
      if (this.form_data.name.length > 0) { return true; }
      return false;
    }
  },
  mounted() {
    
  },
  data() {
    return {
      email_template_options: [],
      lastAutoSaveTime: 0,
      autoSaveInterval: 60 * 1000,

      form_data: {
        id: null,
        name: '',
        customer_id: null,
        company_id: null,
        created_at: '',
        descr: '',
        is_member: false,
        is_user: false,
        is_public: false,
        is_email_active: false,
        linkstr: '',
        deleted: false,
        items: [],
        timeout_template_id: null,
        timeout_days: null,
        timeout_emails: []
      },
      
      selected_item: 0,
      mini: false,
      unlocked_sections: [
        { title: this.$t('TEMPLATE.BASIC'), icon: 'mdi-information-outline', name: 'basic_info', hide_on_create: false },
        { title: this.$t('TEMPLATE.DESIGN'), icon: 'mdi-palette-outline', name: 'designer', hide_on_create: true },
        { title: this.$t('TEMPLATE.ATTACHMENTS'), icon: 'mdi-paperclip', name: 'attachments', hide_on_create: true },
        { title: this.$t('TEMPLATE.QUESTIONS'), icon: 'mdi-comment-question', name: 'questions', hide_on_create: true },
        { title: this.$t('TEMPLATE.SENDER'), icon: 'mdi-email', name: 'sender', hide_on_create: true },
      ],

      merge_tag: null,
      attachments: [],
      active_tab: 0,
      sendout_template_type: null,
      instance_id: null,
      instance_options: [],
      form_data: {},
      isValid: true,

      replyToValid: false,
      fromEmailValid: false,
      stickprov: false,
      email: false,
      moving: false,
      templates: [],
      fullscreen: false,
    };
  },

  watch: {
    question_form_id: {
      handler(newVal) {

        if (this.question_form_id) {
          this.fetch_form(this.question_form_id);
        }
        else {
          this.form_data = {
            
          };
        }

        this.load_templates();
      },
      deep: true,
      immediate: true,
    },

  },
  methods: {

    show() {
      this.$refs['survey-editor-modal'].show();
    },
    hide() {
      this.$refs['survey-editor-modal'].hide();
    },

    async fetch_form(id) {
      const res = await axios.get(`/question_form/${id}`);

      if (res.status === 200) {
        this.form_data = res.data;
      }
    },
    async save_group() {
      this.saving = true;
      try {
        if (this.form_data.id) {
          // UPDATE EXISTING FORM
          await axios.put(`/question_form/${this.form_data.id}`, this.form_data);
          this.$emit('updated', this.form_data);
        } else {

          this.form_data.company_id = this.currentCompanyId;
          this.form_data.customer_id = this.customer.id;

          // CREATE NEW FORM
          const response = await axios.post('/question_form', this.form_data);
          this.$emit('created', response.data);
          this.form_data.id = response.data.id;
        }
        this.hide();
      } catch (error) {
        console.error('Error saving form:', error);
      } finally {
        this.saving = false;
      }
    },
    async load_templates() {
      try {
        const res = await axios.get(`/template?company_id=${this.currentCompanyId}`);

        if (res.status === 200) {
          
          this.email_template_options = res.data.filter(i => !i.is_sms).map(i => ({ value: i.template_id, text: i.name }));
          this.email_template_options.unshift({ value: null, text: this.$t('COMMON.NONE') });
          return;
        }
      }
      catch (err) {
        console.error('load_templates', err);
      }

      this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('TEMPLATE.UNABLE_LIST'));
    },
    list_item_group_change() {
      if (is_mobile()) {
        this.mini = true;
      }
    },
    on_drawer_item_click({ index, value, text }) {
      this.selected_item = index
      this.list_item_group_change(index)
    },
    
    on_template_design_saved(design) {

    },

    async on_template_auto_save(autosave  /*  { edit_html: data, html: val.html } */) {
      
      if (this.form_data.template_id) {
        const now = Date.now();

        if (now - this.lastAutoSaveTime < this.autoSaveInterval) {
          // Skip if less than 1 minute since last save
          return;
        }

        this.lastAutoSaveTime = now;
        
        /*await axios.put(`/template/${this.form_data.template_id}`, {
          template_id: this.form_data.template_id,
          edit_html: JSON.stringify(JSON.stringify(autosave.edit_html)),
          template: autosave.html
        });*/

        //this.toastr('success', this.$t('COMMON.OK'), this.$t('COMMON.AUTOSAVED'));
      }
    },

    on_plaintext_generated(plaintext) {

    },

    goto_url_clicked() {
      //window.open(this.template_public_url, '_blank');
    },


    on_cancel() {
      this.$emit('cancel');
    },

    async submit_form() {
      this.get_design();
      this.save_group();

      this.$refs['saveButton'].stop();
    },


    async get_design() {
      
      if (this.$refs['survey-unlayer-editor']) {
        const design_data = await this.$refs['survey-unlayer-editor'].exportHTML();


        return {
          edit_html: JSON.stringify(JSON.stringify(design_data.edit_html)),
          html: design_data.html
        };
        
      }

      throw 'unable to get design';

    },
  }
};
</script>

<style lang="scss" scoped>


.modal-xl {
  max-width: 100% !important;
  padding-right: 17px;
}

:deep .dark-modal {
  color: white;
  background-color: #293039;
  border-bottom: 1px solid #444c56;
}

:deep .dark-modal-body {
  color: white;
  background-color: #293039;
}

.ml-url-link:hover {
  cursor: pointer;
}

.row {
  margin-top: -12px !important;
}

.page-container {
  height: 100%;
  display: flex;
  flex-flow: column;
}

.fill-rest {
  flex: 1 1 auto;
}


.quick-search-card {
  overflow: scroll;
}

.selected-item-active {
  border-radius: 4px;
  background: #f4fcff;
  color: black;
}

.card-title {
  background-color:#f7f7f7;
  border-bottom:1px solid #dedede;
  padding-bottom: 15px;

}

.card-title-p {
  margin-bottom: 8px !important;
  margin-top: 7px !important;
}


.top-container {
  display: flex;
}

.content {
  flex-grow: 1;
  margin-top: 0px !important;
  padding-top: 0px !important;
  margin-left: 8px !important;
}



.drawer-header {
  margin-bottom: -13px !important;
}

.drawer {
  border-right: 1px solid #dddddd !important;
}

.fixed-font {
  font-size: 0.95rem !important;
  font-weight: 500;
  line-height: 1rem;
}

:deep .v-application--wrap {
  min-height: 0px !important;
}

.ml-url-link:hover {
  cursor: pointer;
}

</style>

